import { lazy } from "react";

export const ProductsV2Home = lazy(
  () => import("./Interface/ConstructionHome/ConstructionHome"),
);
export const ProductsV2Details = lazy(
  () => import("./Interface/ConstructionDetails/ConstructionDetails"),
);
export const AllProductsV2 = lazy(
  () => import("./Interface/ProductsV2/AllProducts"),
);
